import { create } from "zustand";

interface UIState {
  /** Artifact currently open in the side panel. */
  artifactId: string | null;
  openArtifact: (id: string | null) => void;
}

export const useUI = create<UIState>((set) => ({
  artifactId: null,
  openArtifact: (id) => set({ artifactId: id }),
}));
